import tokens from 'config/constants/tokens'
import { useMemo } from 'react'
import { useDeserializedFarms } from 'state/farms/useDeserializedFarms'
import { usePriceVvsUsdc } from 'state/farms/hooks'
import { getFarmApr } from 'utils/apr'
import BigNumber from 'bignumber.js'
import { getAddress } from 'utils/addressHelpers'
import { Pair } from 'vvs-sdk'

const { wcro: WCRO } = tokens

type SmartAprProp = { currencyIdA: string; currencyIdB: string } | Pair

export default function useSmartApr(prop: SmartAprProp) {
  const vvsPrice = usePriceVvsUsdc()
  const farmsLP = useDeserializedFarms((s) => s.value.farms)
  const targetFarm = farmsLP.find((farm) => {
    // do not include finished farms
    if (farm.isFinished) return false

    // prop is Pair
    if (prop instanceof Pair) {
      const pair = prop as Pair
      return (
        (farm.quoteToken.address === pair.token1.address && farm.token.address === pair.token0.address) ||
        (farm.quoteToken.address === pair.token0.address && farm.token.address === pair.token1.address)
      )
    }

    // prop is currencyIds
    const { currencyIdA, currencyIdB } = prop || {
      currencyIdA: '',
      currencyIdB: '',
    }
    if (currencyIdA === 'CRO' || currencyIdA === WCRO.address) {
      return farm.quoteToken.address === WCRO.address && farm.token.address === currencyIdB
    }
    if (currencyIdB === 'CRO' || currencyIdB === WCRO.address) {
      return farm.quoteToken.address === WCRO.address && farm.token.address === currencyIdA
    }
    return (
      (farm.quoteToken.address === currencyIdA && farm.token.address === currencyIdB) ||
      (farm.quoteToken.address === currencyIdB && farm.token.address === currencyIdA)
    )
  })
  const farmApr = useMemo((): number => {
    if (!targetFarm) return 0
    const totalLiquidity = new BigNumber(targetFarm.lpTotalInQuoteToken).times(targetFarm.quoteTokenPriceUsdc)
    // TODO: Review the apr here
    const { vvsRewardsApr, lpRewardsApr } = getFarmApr(
      new BigNumber(targetFarm.poolWeight),
      vvsPrice,
      totalLiquidity,
      getAddress(targetFarm.lpAddresses),
    )
    return vvsRewardsApr + lpRewardsApr
  }, [vvsPrice, targetFarm])

  return { farmApr, targetFarm }
}
